import { html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { UIModalServiceModal } from '../../../../app/package/base/service/modals/modal-service';
import { I18n } from '../../../base/package/services/package/i18n/i18n.de';
import type { UIModal } from '../../ui-modal/ui-modal';
import styles from './ui-panic-modal.css?inline';
import '../../icons/ui-stop-icon';

const CName = 'ui-panic-modal';

@customElement(CName)
export class UIPanicModal extends UIModalServiceModal {
  static readonly styles = unsafeCSS(styles);
  @property() action: () => void;

  public close() {
    this._modalRef.value?.close();
  }

  protected firstUpdated(): void {
    if (this.action) {
      setTimeout(this.action, window.$app.appSettings.panicButtonTTL);
    }
  }

  render() {
    return html`
      <ui-modal
        ${ref(this._modalRef)}
        .isDismissible=${false}
        .onAction=${(e: UIModal) => {
          this.action?.();
          e.close();
        }}
        .actionButtonLabel=${window.$app.$t.get(I18n.base.ok)}
        class="modal--centered"
      >
        <div slot="title">
          <div class="stop">
            <ui-stop-icon></ui-stop-icon>
          </div>
          ${window.$app.$t.get(I18n.panic.modalTitle)}
        </div>
        <div class="content" slot="main">
          <div>${window.$app.$t.get(I18n.panic.modalText)}</div>
        </div>
      </ui-modal>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIPanicModal;
  }
}
